import { createFileRoute } from "@tanstack/react-router";
import { PlaybookPage } from "@/components/paid-media/playbook";

export const Route = createFileRoute("/dashboard/paid-media/_layout/playbook")({
  component: PlaybookPage,
});
